import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { AuthLayout } from '../../../components/generic/Layouts/AuthLayout'
import { Eyebrow } from '../../../components/generic/ui/Eyebrow'
import { AuthHeading } from '../../../components/generic/ui/Heading'
import { TextInput, PasswordInput } from '../../../components/generic/ui/Input'
import { AccentButton } from '../../../components/generic/ui/Button'
import { UseLoginFormReturn } from './LoginForm.types'

const ArrowLeft = (
  <svg
    width="16"
    height="16"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2.2}
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M19 12H5M12 19l-7-7 7-7" />
  </svg>
)

export const LoginFormView: React.FC<UseLoginFormReturn> = ({
  username,
  password,
  isInternal,
  isLoading,
  inviteToken,
  setUsername,
  setPassword,
  setInternal,
  handleSubmit,
}) => (
  <AuthLayout>
    <Eyebrow>AGROLINE / SIGN IN</Eyebrow>
    <AuthHeading subtitle="שמחים לראות אתכם שוב">
      כניסה<br />למערכת
    </AuthHeading>

    <Form onSubmit={handleSubmit}>
      <TextInput
        label="שם משתמש"
        name="username"
        type="text"
        placeholder="moshe.cohen"
        autoComplete="username"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
        required
      />

      <PasswordInput
        label="סיסמה"
        name="password"
        placeholder="••••••••"
        autoComplete="current-password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        required
      />

      {!inviteToken && (
        <Checks>
          <label>
            <input
              type="checkbox"
              checked={isInternal}
              onChange={(e) => setInternal(e.target.checked)}
            />
            <span>משתמש פנימי</span>
          </label>
        </Checks>
      )}

      <AccentButton type="submit" disabled={isLoading} iconRight={ArrowLeft}>
        {isLoading ? 'טוען...' : 'המשך'}
      </AccentButton>

      <ForgotRow>
        <Link to="/reset">שכחת סיסמה?</Link>
      </ForgotRow>

      {inviteToken && (
        <RegisterRow>
          <Link to={`/registration?token=${inviteToken}`}>הרשמה</Link>
        </RegisterRow>
      )}
    </Form>
  </AuthLayout>
)
LoginFormView.displayName = 'LoginFormView'

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
`

const Checks = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  font-size: 0.8125rem;

  label {
    display: inline-flex;
    align-items: center;
    gap: 0.625rem;
    cursor: pointer;
    color: ${({ theme }) => theme.colors.ink2};
  }

  input[type='checkbox'] {
    width: 1rem;
    height: 1rem;
    accent-color: ${({ theme }) => theme.colors.ink};
    cursor: pointer;
  }
`

const ForgotRow = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 0.5rem;
  font-size: 0.8125rem;

  a {
    color: ${({ theme }) => theme.colors.ink2};
    text-decoration: none;
    font-weight: 500;
    border-bottom: 1px solid transparent;
    transition: border-color ${({ theme }) => theme.motion.fast},
      color ${({ theme }) => theme.motion.fast};
  }

  a:hover {
    color: ${({ theme }) => theme.colors.ink};
    border-bottom-color: ${({ theme }) => theme.colors.ink};
  }
`

const RegisterRow = styled(ForgotRow)`
  margin-top: 0.25rem;
`

export default LoginFormView
